
import React from 'react';
import { CircuitBoard } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NeoPrismaAcademyLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

const NeoPrismaAcademyLogo: React.FC<NeoPrismaAcademyLogoProps> = ({ 
  size = 'md', 
  showText = true, 
  className 
}) => {
  const sizes = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className={cn(
        'rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white',
        sizes[size]
      )}>
        <CircuitBoard className="w-4 h-4" />
      </div>
      {showText && (
        <span className={cn(
          'font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent',
          textSizes[size]
        )}>
          Neo Prism Academy
        </span>
      )}
    </div>
  );
};

export default NeoPrismaAcademyLogo;
